import { Box, Divider, VStack } from '@chakra-ui/react';
import type { StudentType } from './StudentDetailPage';
import AdditionalDetailsView from './StudentPersonalDetails/AdditionalDetailsView';
import AddressDetailsView from './StudentPersonalDetails/AddressDetailsView';
import BasicDetailsView from './StudentPersonalDetails/BasicDetailsView';
import type { States } from '@duke-hq/svc-api-db/schemas/enums/States.schema';

export function StudentUserDetail(props: {
  student: Omit<
    StudentType,
    'postcodeWarnings' | 'consultantDrn' | 'providerDrn' | 'providerId' | 'notesDrn'
  > & {
    postcodeWarnings?: StudentType['postcodeWarnings'];
  };
  shouldRefetchAvetmiss?: boolean;
}): React.ReactElement {
  const { student, shouldRefetchAvetmiss = false } = props;

  return (
    <Box p={4}>
      <VStack spacing={4} gap={0} align="stretch">
        <BasicDetailsView
          studentId={student?.id}
          firstName={student?.first_name}
          lastName={student?.last_name}
          preferredName={student?.studentData?.preferred_name}
          email={student?.email}
          secondaryEmail={student?.secondaryEmail}
          phoneNumber={student?.phone_number}
          universalStudentIdentifier={student?.studentData?.universal_student_identifier}
          isUsiVerified={student?.studentData?.usi_verified_at != null}
          hasAccreditedEnrolment={student?.hasAccreditedEnrolment ?? false}
          shouldRefetchAvetmiss={shouldRefetchAvetmiss}
        />

        <Divider my={2} />

        <AddressDetailsView
          studentId={student?.id}
          addressFields={{
            addressState: (student?.studentData?.addressState as States) ?? undefined,
            addressLocality: student?.studentData?.addressLocality ?? undefined,
            addressStreetName: student?.studentData?.addressStreetName ?? undefined,
            addressStreetNumber: student?.studentData?.addressStreetNumber ?? undefined,
            addressStreetSubpremise: student?.studentData?.addressStreetSubpremise ?? undefined,
            addressPostcode: student?.studentData?.addressPostcode ?? undefined,
            formattedAddress: student?.studentData?.formattedAddress ?? undefined,
            postalAddressStreetName: student?.studentData?.postalAddressStreetName ?? undefined,
            postalAddressLocality: student?.studentData?.postalAddressLocality ?? undefined,
            postalAddressState: (student?.studentData?.postalAddressState as States) ?? undefined,
            postalAddressPostcode: student?.studentData?.postalAddressPostcode ?? undefined,
            postalAddressStreetSubpremise:
              student?.studentData?.postalAddressStreetSubpremise ?? undefined,
          }}
          postcodeWarnings={student?.postcodeWarnings}
          shouldRefetchAvetmiss={shouldRefetchAvetmiss}
        />

        <Divider my={2} />

        <AdditionalDetailsView
          studentId={student?.id}
          dateOfBirth={student?.studentData?.date_of_birth ?? undefined}
          gender={student?.studentData?.gender ?? undefined}
          highestEducation={student?.studentData?.highest_education ?? undefined}
          disabilities={student?.studentData?.disabilities ?? undefined}
          countryOfBirth={student?.studentData?.country_of_birth ?? undefined}
          isUsiVerified={student?.studentData?.usi_verified_at != null}
          shouldRefetchAvetmiss={shouldRefetchAvetmiss}
        />
      </VStack>
    </Box>
  );
}
